<template>
    <b-container class="reset-password">
        <b-row v-if="showInput">
            <b-col>
                <b-row class="reset-password-title">
                    <b-col>{{$t('reset_password.title')}}</b-col>
                </b-row>
                <b-row>
                    <b-col lg="6">
                        <b-form-input :placeholder="$t('register.password')"
                                      v-model="newPassword"
                                      type="password"
                                      autocomplete="new-password"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6">
                        <b-form-input :placeholder="$t('register.confirm_password')"
                                      v-model="confirmPassword"
                                      type="password"
                                      autocomplete="new-password"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="password-criteria">
                    <b-col>
                        <font-awesome-icon :icon="passwordContainsEightCharacters ? 'check' : 'times'"></font-awesome-icon>
                        {{$t('register.password_contain_eight_characters')}}
                    </b-col>
                </b-row>
                <b-row class="password-criteria">
                    <b-col>
                        <font-awesome-icon :icon="passwordContainsLetter ? 'check' : 'times'"></font-awesome-icon>
                        {{$t('register.password_contain_letters')}}
                    </b-col>
                </b-row>
                <b-row class="password-criteria">
                    <b-col>
                        <font-awesome-icon :icon="passwordContainsNumbers ? 'check' : 'times'"></font-awesome-icon>
                        {{$t('register.password_contain_numbers')}}
                    </b-col>
                </b-row>
                <b-row class="password-criteria">
                    <b-col>
                        <font-awesome-icon :icon="passwordContainsSpecialCharacter ? 'check' : 'times'"></font-awesome-icon>
                        {{$t('register.password_contain_special_characters')}}
                    </b-col>
                </b-row>
                <b-row class="password-criteria">
                    <b-col>
                        <font-awesome-icon :icon="newPassword && (newPassword === confirmPassword) ? 'check' : 'times'"></font-awesome-icon>
                        {{$t('register.password_match')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3">
                        <b-button :disabled="!passwordValid" @click="resetPassword" variant="primary" class="reset-password-btn">{{$t('reset_password.title')}}</b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <b-row v-if="showErrorMsg">
            <b-col>
                <b-row class="reset-password-title">
                    <b-col>{{$t('reset_password.title')}}</b-col>
                </b-row>
                <b-row class="reset-password-error-msg">
                    <b-col>{{$t('reset_password.error_msg')}}</b-col>
                </b-row>
            </b-col>
        </b-row>


        <b-modal id="resetSuccessModal"
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <b-container class="reset-success-container">
                <b-row>
                    <b-col class="reset-success-icon">
                        <font-awesome-icon :icon="['far', 'envelope']"></font-awesome-icon>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="reset-success-title">
                        {{$t('reset_password.modal_title')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{$t('reset_password.modal_content')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button class="reset-success-close-btn"
                                  @click="closeModal">{{$t('close')}}
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </b-container>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEnvelope} from '@fortawesome/free-regular-svg-icons'

    library.add(faEnvelope);

    export default {
        name: 'AdminResetPassword',
        components: {},
        data() {
            return {
                token: this.$route.params.token,

                showInput: false,
                showErrorMsg: false,

                newPassword: '',
                confirmPassword: '',
            };
        },
        mounted() {
            this.verifyToken();
        },
        computed: {
            passwordContainsEightCharacters() {
                return this.newPassword && this.newPassword.length >= 8;
            },
            passwordContainsLetter() {
                return !!this.newPassword.match(/[A-Za-z]/g);
            },
            passwordContainsNumbers() {
                return !!this.newPassword.match(/[0-9]/g);
            },
            passwordContainsSpecialCharacter() {
                return !!this.newPassword.match(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g) && !this.newPassword.match(/[ ]/g);
            },
            passwordValid() {
                return this.passwordContainsEightCharacters && this.passwordContainsLetter && this.passwordContainsNumbers && this.passwordContainsSpecialCharacter && this.newPassword === this.confirmPassword;
            },
        },
        methods: {
            verifyToken() {
                this.$callAPI('hkiarace/admin/reset_password_verify/', {token: this.token}, function (response) {
                    this.showInput = true;
                }, function (response) {
                    this.showErrorMsg = true;
                })
            },
            resetPassword() {
                this.$callAPI('hkiarace/admin/reset_password/', {token: this.token, new_password: this.newPassword}, function (response) {
                    this.$bvModal.show("resetSuccessModal");
                });
            },
            closeModal() {
                this.$bvModal.hide('resetSuccessModal');
                this.$router.push({name: 'admin-login'});
            },
        }
    }
</script>

<style lang="less">
    .reset-password {
        text-align: left;
        padding: 24px;

        .reset-password-title {
            font-weight: bold;
            font-size: 1.3rem;
        }

        .row {
            margin-bottom: 1rem;
        }

        .form-control {
            border-radius: 0;
            border: none;
            border-bottom: 1px solid #ced4da;
        }

        .reset-password-btn {
            width: 100%;
            background-color: #3b3a53;
            border-color: #3b3a53;
            color: white;
            font-weight: bold;
        }

        .forgot-pw-link {
            color: #798188;
        }

        .password-criteria {
            padding-left: 15px;
            font-size: 90%;

            .fa-check {
                color: green;
            }
            .fa-times {
                color: red;
            }
        }
    }

    #resetSuccessModal {
        text-align: center;

        .reset-success-container {
            padding-top: 48px;
            font-size: 1.5rem;

            .row {
                margin-bottom: 2rem;
            }

            .reset-success-icon {
                font-size: 5rem;
            }

            .reset-success-title {
                font-weight: bold;
                font-size: 2.5rem;
            }

            .reset-success-close-btn {
                background-color: black;
                border-radius: 0;
                width: 100%;
                font-size: 1.5rem;
            }
        }
    }
</style>